import { CONSTANT } from '../../../constant/constant';
import { ENDPOINTS } from '../../../constant/endpoints';
import {
    generalHttpGetRequest,
    generalHttpPostRequest,
    generalHttpPutRequest
} from '../../../helper/request-helper';

const fetchTrustUrl = CONSTANT.baseUrl + ENDPOINTS.employee.trust.fetchTrust;
const fetchTrustFilingsUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.trust.fetchTrustFilings;
const fetchTrustsByClientUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.trust.fetchTrustByClient;
const fetchTrustsHistoryUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.trust.fetchTrustHistory;
const addEditNewTrustUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.trust.addEditNewTrust;
const fetchSalesUrl = CONSTANT.baseUrl + ENDPOINTS.employee.sales.fetchSales;
const fetchAdminSalesUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.sales.fetchAdminSales;

export const actionType = {
    REQUESTED_TRUST_DATA: 'REQUESTED_TRUST_DATA',
    REJECTED_TRUST_DATA: 'REJECTED_TRUST_DATA',
    FETCH_TRUST_BY_CLIENT: 'FETCH_TRUST_BY_CLIENT',
    FETCH_TRUST_HISTORY: 'FETCH_TRUST_HISTORY',
    EDIT_TRUST: 'EDIT_TRUST',
    FETCH_TRUST: 'FETCH_TRUST',
    FETCH_TRUST_FILINGS: 'FETCH_TRUST_FILINGS',
    UPDATE_EDIT_TRUST_PAYLOAD: 'UPDATE_EDIT_TRUST_PAYLOAD',
    UPDATE_TRUST_HISTORY_ITEM_SELECTED: 'UPDATE_TRUST_HISTORY_ITEM_SELECTED',
    ADD_NEW_TRUST: 'ADD_NEW_TRUST',
    UPDATE_ADD_NEW_TRUST_PAYLOAD: 'UPDATE_ADD_NEW_TRUST_PAYLOAD',
    HANDLE_ADD_TRUST_VISIBILITY: 'HANDLE_ADD_TRUST_VISIBILITY',
    HANDLE_EDIT_TRUST_VISIBILITY: 'HANDLE_EDIT_TRUST_VISIBILITY',
    HANDLE_VIEW_TRUST_VISIBILITY: 'HANDLE_VIEW_TRUST_VISIBILITY',
    FETCH_TRUST_SALES: 'FETCH_TRUST_SALES',
    FETCH_TRUST_ADMIN_SALES: 'FETCH_TRUST_ADMIN_SALES',
    CLEAR_TRUSTS_LIST: 'CLEAR_TRUSTS_LIST'
};

export const fetchTrustData = trustId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_TRUST_DATA
        });

        return generalHttpGetRequest(fetchTrustUrl + trustId)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_TRUST,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_TRUST_DATA,
                    data: error
                });
            });
    };
};

export const fetchTrustFilings = trustId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_TRUST_DATA
        });

        return generalHttpGetRequest(fetchTrustFilingsUrl + trustId)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_TRUST_FILINGS,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_TRUST_DATA,
                    data: error
                });
            });
    };
};

export const fetchTrustSales = params => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_TRUST_DATA
        });

        return generalHttpGetRequest(fetchSalesUrl, params)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_TRUST_SALES,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_TRUST_DATA,
                    data: error
                });
            });
    };
};

export const fetchTrustAdminSales = params => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_TRUST_DATA
        });

        return generalHttpGetRequest(fetchAdminSalesUrl, params)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_TRUST_ADMIN_SALES,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_TRUST_DATA,
                    data: error
                });
            });
    };
};

export const fetchTrustByClient = clientId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_TRUST_DATA
        });

        return generalHttpGetRequest(fetchTrustsByClientUrl + clientId)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_TRUST_BY_CLIENT,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_TRUST_DATA,
                    data: error
                });
            });
    };
};

export const fetchTrustHistory = trustId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_TRUST_DATA
        });

        return generalHttpGetRequest(fetchTrustsHistoryUrl + trustId)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_TRUST_HISTORY,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_TRUST_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const addNewTrust = payload => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_TRUST_DATA
        });

        return generalHttpPostRequest(addEditNewTrustUrl, payload)
            .then(response => {
                dispatch({
                    type: actionType.ADD_NEW_TRUST,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_TRUST_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const editTrust = payload => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_TRUST_DATA
        });

        return generalHttpPutRequest(addEditNewTrustUrl, payload)
            .then(response => {
                dispatch({
                    type: actionType.EDIT_TRUST,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_TRUST_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const updateAddNewTrustPayload = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_ADD_NEW_TRUST_PAYLOAD,
            payload: selected
        });
    };
};

export const updateTrustHistoryItemSelected = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_TRUST_HISTORY_ITEM_SELECTED,
            payload: selected
        });
    };
};

export const updateEditTrustPayload = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_EDIT_TRUST_PAYLOAD,
            payload: selected
        });
    };
};

export const clearTrustsList = () => {
    return dispatch => {
        return dispatch({
            type: actionType.CLEAR_TRUSTS_LIST
        });
    };
};

export const handleAddTrustVisibility = visibility => {
    return dispatch => {
        dispatch({
            type: actionType.HANDLE_ADD_TRUST_VISIBILITY,
            visibility: visibility
        });
    };
};

export const handleEditTrustVisibility = visibility => {
    return dispatch => {
        dispatch({
            type: actionType.HANDLE_EDIT_TRUST_VISIBILITY,
            visibility: visibility
        });
    };
};

export const handleViewTrustVisibility = visibility => {
    return dispatch => {
        dispatch({
            type: actionType.HANDLE_VIEW_TRUST_VISIBILITY,
            visibility: visibility
        });
    };
};



// WEBPACK FOOTER //
// ./src/services/redux/employee/trust/actions.js